<template>
  <b-modal size="lg" ref="modal" hide-header hide-footer>
    <div class="row no-gutters my-5 mx-5 text-center">
      <div class="col-md-3 mx-auto mb-3">
        <img :src="addedIntoLibrary" width="70px">
      </div>
      <div class="col-12">
        <p class="h4 mb-0">{{ bookTitle }}</p>
        <p class="p py-2 mb-0">è stato inserito nella tua libreria.</p>
      </div>
    </div>
    <form @submit.prevent="submitForm">
      <div class="row py-4">
        <div class="col-12">
          <div class="col-12 h2 text-center mb-4">Vuoi scambiarlo o venderlo ?</div>
          <div class="row pb-4">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button @click="commerceBook.can_swap = !commerceBook.can_swap" class="btn btn-outline-senary text-uppercase" type="button">
                  <i
                    class="far"
                    :class="{
                      'fa-circle': !commerceBook.can_swap,
                      'fa-check-circle': commerceBook.can_swap,
                    }"></i>
                  Voglio scambiarlo
                </button>
                <button @click="sellSelected" class="btn btn-outline-quaternary text-uppercase" type="button" id="btn-sell">
                  <i
                    class="far"
                    :class="{
                      'fa-circle': !commerceBook.can_sell,
                      'fa-check-circle': commerceBook.can_sell,
                    }"></i>
                  Voglio venderlo
                </button>
                <button @click="giftSelected" class="btn btn-outline-secondary text-uppercase" type="button" id="btn-gift">
                  <i
                    class="far"
                    :class="{
                      'fa-circle': !commerceBook.can_gift,
                      'fa-check-circle': commerceBook.can_gift,
                    }"></i>
                  Voglio regalarlo
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-row">
                <div class="form-group col-md-5">
                  <label class="small font-weight-bold" for="priceInput">Prezzo</label>
                  <input :required="commerceBook.can_sell" v-model="formattedPrice" type="number" min="0.1" step="0.1" class="form-control" name="price" id="priceInput" placeholder="Il tuo prezzo" :disabled="!commerceBook.can_sell">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label class="small font-weight-bold" for="conditionInput">Stato libro</label>
                  <div class="select-input">
                    <select v-model="commerceBook.condition" class="form-control" id="conditionInput" name="condition">
                      <option :value="null" selected disabled>Non inserito</option>
                      <option value="excellent">Come nuovo</option>
                      <option value="new">Ottimo</option>
                      <option value="good">Buono</option>
                      <option value="worn">Usurato</option>
                      <option value="vintage">Vintage</option>
                    </select>
                    <i class="fa fa-chevron-down"></i>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12">
                  <label class="small font-weight-bold" for="notes">Note</label>
                  <textarea v-model="commerceBook.notes" class="form-control" name="notes" id="notes"></textarea>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-end">
                  <button @click="$refs.modal.hide()" type="button" class="btn btn-link text-uppercase font-weight-bold" aria-label="Close">Non ora</button>
                  <button type="submit" class="btn btn-secondary text-white text-uppercase">Salva</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import addedIntoLibrary from '../../../../images/added_into_library.svg';
import AddBookIntoCommerce from '../../../graphql/AddBookIntoCommerce.graphql';
import AddBookIntoLibrary from '../../../graphql/AddBookIntoLibrary.graphql';
export default {
  name: "LibraryModal",
  data() {
    return {
      addedIntoLibrary,
      commerceBook: {
        can_swap: false,
        can_sell: false,
        can_gift: false,
        condition: null,
        price: null,
        notes: null,
      }
    }
  },
  props: {
    bookVersionId: Number,
    bookTitle: String,
  },
  computed: {
    formattedPrice: {
      get() {
        return this.commerceBook.price;
      },
      set(value) {
        if (value === '') {
          this.commerceBook.price = null;
          return;
        }
        this.commerceBook.price = parseFloat(value);
      }
    }
  },
  methods: {
    open() {
      this.$refs.modal.show();
      this.$apollo.mutate({
        mutation: AddBookIntoLibrary,
        variables: {
          book_version_id: this.bookVersionId,
        }
      })
    },
    sellSelected() {
      this.commerceBook.can_gift = false;
      this.commerceBook.can_sell = !this.commerceBook.can_sell;
    },
    giftSelected() {
      this.commerceBook.can_sell = false;
      this.commerceBook.can_gift = !this.commerceBook.can_gift;
    },
    submitForm() {
      this.$apollo.mutate({
        mutation: AddBookIntoCommerce,
        variables: {
          book_version_id: this.bookVersionId,
          commerce_book_input: this.commerceBook,
        },
      }).then((data) => {
        this.$refs.modal.hide();
        this.$bvToast.toast(`Libro aggiunto in commercio`, {
          title: 'Commercio',
          variant: 'success',
          autoHideDelay: 3000,
          appendToast: true,
        })
      }).catch((error) => {
        this.$bvToast.toast(`Errore durante l'aggiunta in commercio, riprova più tardi`, {
          title: 'Commercio',
          variant: 'danger',
          autoHideDelay: 3000,
          appendToast: true,
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
